<template>
  <div class="ruleContent">
    <p class="title">客 户 告 知 书</p>
    <p>尊敬的客户：</p>
    <p>
      感谢您委托我公司代为办理保险业务。本公司是基于投保人的利益，为投保人与订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪人监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请您仔细阅读，并在回执处予以签字（盖章）确认：</p>
    <p>一、 公司基本情况</p>
    <p>(一) 公司名称:升华茂林保险销售服务有限公司四川分公司</p>
    <p>(二) 营业场所: 成都高新区九兴大道6号B座</p>
    <p>(三) 统一社会信用代码：91510100MA62NG5B0H</p>
    <p>(四) 许可证有效期止期：2024年12月26日</p>
    <p>
      (五) 业务范围：在全国区域内（港、澳、台除外）为投保人拟订投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估，风险管理咨询服务；中国保监会批准的其他业务。</p>
    <p>(六) 联系电话： 18113098830 </p>
    <p>
      二、 根据保险监管部门的规定，只有持《保险经纪从业人员执业证书》的人员方可从事保险经纪业务，您可要求本公司业务人员出示《保险经纪从业人员执业证书》，并可通过登录中国保监会保险中介监管信息系统查询业务人员持证情况（http://iir.circ.gov.cn）；</p>
    <p>三、本公司已按照《保险经纪人监管规定》投保了职业责任保险；</p>
    <p>四、本公司及高级管理人员与经纪业务相关的、其他保险中介机构不存在关联关系； </p>
    <p>五、本公司从业人员会根据您的保险需求与风险承受能力等情况，在客观分析市场上同类保险产品的基础上，为您推荐符合其利益的保险产品；</p>
    <p>六、本公司从业人员会按照中国保监会的要求向您披露保险产品相关信息。同时，请您仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算等内容，您可以要求本公司从业人员对上述内容进行详细讲解。</p>
    <p>
      七、请您向本公司业务人员了解《中华人民共和国保险法》等法律法规中对于索赔时效、补偿时限、合同中止与失效、保险标的转让、重复保险等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失等情形导致的法律后果。</p>
    <p>八、您同意本公司就本项目通过以下方式收取费用：</p>
    <p>(一) 向收取佣金                                            是√   否□</p>
    <p>(二) 向您收取咨询费/服务费                                         是□   否√</p>
    <p>九、根据《中华人民共和国保险法》的规定，因保险经纪人过错给投保人、被保险人和受益人造成损失的，应依法承担赔偿责任。</p>
    <p>
      十、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司进行投诉；发生争议时，双方应及时协商解决，协商不成的，您可以向本公司所在地人民法院提起诉讼。</p>
    <p> </p>
    <p>  </p>
    <p> 升华茂林保险销售服务有限公司四川分公司</p>
  </div>
</template>

<script>
export default {
  name: "khgzs"
}
</script>

<style lang="scss" scoped>
.ruleContent {
  padding: 9px;
  background: #fff;
  min-height: 100%;
  font-size: 14px;
  color: #0C0C0C;
  line-height: 25px;
  //width: 100%;
  max-height: 500px;
  overflow: auto;
  margin: 0 auto;
  .title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// khgzs.vue?9d8c43e6